import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
    margin: theme.spacing(1),
  },
}));

const ResourceTypeSelect = ({resourceType, setResourceType}) => {
  const classes = useStyles();

  const handleChange = (event) => {
    setResourceType(event.target.value);
  };

  return (
    <FormControl className={classes.formControl}>
      <InputLabel id="resource-type-label">Resource Type</InputLabel>
      <Select
        labelId="resource-type-label"
        id="resource-type-select"
        value={resourceType}
        onChange={handleChange}
      >
        <MenuItem value="accountMeter">Account Meter</MenuItem>
        <MenuItem value="meter">Meter</MenuItem>
      </Select>
    </FormControl>
  );
};

export default ResourceTypeSelect;